import { IconHeader, Divider } from "../../../components";
import { FormTextInput, FormRadioGroup } from "../../../features/auto-form";
import { useTranslate } from "../../../features/translation/hooks/use-translation";

const GroupSize = () => {
  const { t } = useTranslate();
  return (
    <div className="container">
      <div className="row">
        <div className="col col-12">
          <IconHeader
            title={t("form.groupDetails.groupSize.title")}
            icon="user"
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-12">
          <div
            className="text base"
            dangerouslySetInnerHTML={{
              __html: t("form.groupDetails.groupSize.description"),
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-12 col-sm-6 col-md-4">
          <FormTextInput
            name="request.groupInformation.pax.adults"
            languagesection="form.groupDetails.groupSize.adults"
            placeholder="0"
            defaultValue="0"
            type="number"
            min={1}
            max={300}
            required
          />
        </div>
        <div className="col col-12 col-sm-6 col-md-4">
          <FormTextInput
            name="request.groupInformation.pax.children"
            languagesection="form.groupDetails.groupSize.children"
            placeholder="0"
            defaultValue="0"
            type="number"
            min={0}
            max={100}
            required
          />
        </div>
        <div
          className="col col-12 col-sm-6 col-md-4"
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <FormRadioGroup
            name="request.groupInformation.pax.sizeIs"
            languagesection="form.groupDetails.groupSize"
            className="horizontal"
            defaultValue="exact"
            options={[
              { value: "exact" },
              { value: "estimated" },
            ]}
            required
          />
        </div>
      </div>
    </div>
  );
};

const BudgetRestrictions = () => {
  const { t } = useTranslate();

  return (
    <div className="container request-section">
      <div className="row">
        <div className="col col-12">
          <IconHeader
            title={t("form.groupDetails.budgetRestrictions.title")}
            icon="pricetag"
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-12">
          <div
            className="text base"
            dangerouslySetInnerHTML={{
              __html: t("form.groupDetails.budgetRestrictions.description"),
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-12 col-sm-6 col-md-4">
          <FormTextInput
            name="request.budget.amount"
            languagesection="form.groupDetails.budgetRestrictions.amount"
            trailingText="SEK"
            placeholder="0"
            defaultValue="0"
            type="number"
            max={10000000}
            min={0}
          />
        </div>
        <div
          className="col col-12 col-sm-6 col-md"
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <FormRadioGroup
            name="request.budget.type"
            languagesection="form.groupDetails.budgetRestrictions.type"
            className="horizontal"
            defaultValue="total"
            options={[
              { value: "total" },
              { value: "perPax" },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

const GroupDetails = () => {
  const { t } = useTranslate();

  return (
    <div className="container">
      <div className="row">
        <div className="col col-12">
          <Divider
            className="horizontal thin primary text-title "
            label={t("form.groupDetails.title")}
          />
        </div>
      </div>
      <div
        className="row"
        style={{
          paddingTop: "var(--space-4)",
          paddingBottom: "var(--space-8)",
        }}
      >
        <div className="col col-12">
          <div
            className="text base"
            style={{ textAlign: "center" }}
            dangerouslySetInnerHTML={{
              __html: t("form.groupDetails.description"),
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col col-12">
          <GroupSize />
        </div>
      </div>
      <div className="row">
        <div className="col col-12">
          <BudgetRestrictions />
        </div>
      </div>
    </div>
  );
};

export default GroupDetails;
